import FadeUp from "./FadeUp";
import { FLEET_IMAGES } from "../data/images";

const FEATURES = [
  {
    title: "Instant Booking",
    desc: "Confirm your ride in minutes over call or WhatsApp, with no waiting, no hidden steps.",
    icon: "⚡",
  },
  {
    title: "Professional Chauffeurs",
    desc: "Background-verified, courteous drivers who know routes all across India.",
    icon: "🚘",
  },
  {
    title: "24/7 Support",
    desc: "Early departures or late-night trips, our team is reachable round the clock.",
    icon: "🕑",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="bg-white py-20">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 lg:grid-cols-2 lg:px-8">
        {/* Left: circular image + badge */}
        <FadeUp>
          <div className="relative mx-auto w-fit">
            <div className="h-72 w-72 overflow-hidden rounded-full shadow-cardHover sm:h-96 sm:w-96">
              <img
                src={FLEET_IMAGES.luxury}
                alt="JSR Travels chauffeur and vehicle"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="absolute -right-2 top-6 grid h-24 w-24 animate-float place-items-center rounded-full bg-accent text-center font-heading text-white shadow-cardHover sm:h-28 sm:w-28">
              <span className="text-xl font-extrabold leading-none">30%</span>
              <span className="text-xs font-semibold">OFF</span>
            </div>
            <div className="absolute -left-4 bottom-8 flex items-center gap-2 rounded-card bg-white px-4 py-3 shadow-cardHover">
              <span className="text-2xl">🚘</span>
              <div>
                <p className="font-heading text-sm font-bold text-navy">6+ Vehicle Types</p>
                <p className="text-xs text-navy/50">Sedan to Bus</p>
              </div>
            </div>
          </div>
        </FadeUp>

        {/* Right: copy + features */}
        <div>
          <FadeUp>
            <p className="section-label">← Why Choose Us →</p>
            <h2 className="heading-xl text-3xl sm:text-4xl">
              Great Opportunity For <span className="text-brand">Travel</span> &amp; Adventure
            </h2>
            <p className="mt-4 max-w-lg text-navy/60">
              For years, JSR Travels has moved families, pilgrims and corporate
              teams across Indore, Ujjain, Bhopal and beyond, with clean
              vehicles, fair pricing and a chauffeur you can trust.
            </p>
          </FadeUp>

          <div className="mt-8 space-y-5">
            {FEATURES.map((f, i) => (
              <FadeUp key={f.title} delay={i * 0.1}>
                <div className="flex items-start gap-4">
                  <span className="grid h-12 w-12 shrink-0 place-items-center rounded-full bg-brand-tint text-xl text-brand">
                    {f.icon}
                  </span>
                  <div>
                    <h3 className="font-heading text-lg font-bold text-navy">{f.title}</h3>
                    <p className="text-navy/60">{f.desc}</p>
                  </div>
                </div>
              </FadeUp>
            ))}
          </div>

          <FadeUp delay={0.3}>
            <a href="#tours" className="btn-brand mt-8">
              Explore More →
            </a>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
